<script>
export default {
    name: "GatePassModal",

    data() {

        return {
            gatepass: {},
        };
    },

    props: {
        patient: Object,
        showModal: {
            type: Boolean,
            default: false
        },
    },

    methods: {

        printGatePass() {
            window.open(`/admissions/gate-pass/${this.patient.patientID}/${this.patient.dateAdmitted}`, 
                '_blank', 
                `GatePassPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-11/12 md:w-1/2">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Gate Pass</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-col ">
            <tail-address-header></tail-address-header>
            <hr>  <!-- <div class="w-full flex flex-col justify-center">
                <div class="w-full flex  my-2">
              <h5 class="font-bold text-base uppercase"> 
                Patient Name:<span class="text-blue-700">{{ patient.names }}</span></h5>
            </div>
            <div class="w-full flex justify-center my-2">
               <h5 class="font-bold text-base uppercase"> 
                MRN: <span class="text-blue-700">  {{ patient.patientID }}</span></h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">IP. No: 
                    <span class="text-blue-700">{{ patient.ipfileno || `-` }}</span></h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Admitted On: 
                    <span class="text-blue-700">{{ patient.dateAdmitted | dateFormat }}</span></h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Discharged On: 
                    <span class="text-blue-700">{{ patient.trxDate | dateFormat }}</span></h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Ward: 
                    <span class="text-blue-700">{{ patient.ward }}</span></h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Bed: 
                    <span class="text-blue-700">{{ patient.bed }}</span></h5>
                </div>
                <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Nurse Name: 
                    <span class="text-blue-700">____________________________</span></h5>
                </div>
                
                <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Nurse Signature: 
                    <span class="text-blue-700">____________________________</span></h5>
                </div> <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Nurse Aid Name: 
                    <span class="text-blue-700">____________________________</span></h5>
                </div> <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Nurse Aid Signature: 
                    <span class="text-blue-700">____________________________</span></h5>
                </div> <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Security Person: 
                    <span class="text-blue-700">____________________________</span></h5>
                </div> <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Security Person Signature: 
                    <span class="text-blue-700">____________________________</span></h5>
                </div> -->
                 <!-- <table class="table">
                
                <tbody class="text-xs bg-gray-100 w-full flex flex-col items-center overflow-auto"  >
                    <tr class="w-full flex">
                        <td class="p-tiny flex-1">Patient Name:</td>
                        <td class="p-tiny flex-1">{{ patient.names }}</td>
                        
                    </tr><tr class="w-full flex">
                        <td class="p-tiny flex-1">Patient Name:</td>
                        <td class="p-tiny flex-1">{{ patient.names }}</td>
                        
                    </tr><tr class="w-full flex">
                        <td class="p-tiny flex-1">Patient Name:</td>
                        <td class="p-tiny flex-1">{{ patient.names }}</td>
                        
                    </tr>
                </tbody>
            </table> -->
                <table style="border-bottom-color: Gray; margin-left: 80px; border-bottom-style: solid; border-top-color: Gray; border-top-style: solid; font-family: Lucida Bright; font-weight: bold; padding-top: 0; width: 80%;">
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Patient Names
        </td>
        <td>:
        </td>
        <td>
            <span class="text-blue-700">{{ patient.names }}</span>
        </td>
    </tr>
   
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>MRN
        </td>
        <td>:
        </td>
        <td align="Left">
             
                    <span class="text-blue-700">{{ patient.patientID }}</span> 
        </td>
    </tr>
    
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>IP. No
        </td>
        <td>:
        </td>
        <td align="Left">
            {{ patient.ipfileno || `-` }}
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Admitted On
        </td>
        <td>:
        </td>
        <td align="Left">
            <span class="text-blue-700">{{ patient.dateAdmitted | dateFormat }}</span>
        </td>
    </tr>
    
    
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Discharged On
        </td>
        <td>:
        </td>
        <td align="Left"><span class="text-blue-700">{{ patient.trxDate | dateFormat }}</span>
        </td>
    </tr>
     
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>No Of Days
        </td>
        <td>:
        </td>
        <td align="Left">
            {{ patient.days }}  
        </td>
    </tr>
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Ward ___________
        </td>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td align="Left">
           Bed ___________
        </td>
    </tr>
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared By
        </td>
        <td>:
        </td>
        <td align="Left">
            {{ patient.approvedBy }}
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Name
        </td>
        <td>:
        </td>
        <td align="Left">
           ___________________________
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Aid Name
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Aid Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Security 
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr>
    
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Security Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Finance Name
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Finance Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Pharmacy Name
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Pharmacy Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
</table>
            </div>
        <!-- </div> -->
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-6 rounded" 
            @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
        <button class="btn-primary btn-sm text-xs rounded" 
            @click.prevent="printGatePass"><i class="fa fa-print"></i> Print</button>
      </template>
    </tail-modal>
</template>